import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#7541ed",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-opacity": ".98",
      "stroke-width": "1.714",
      d: "M7.337 9a7.714 7.714 0 1 1 13.594 5.795M1.286 13.286h6.857a4.285 4.285 0 0 1 4.286 4.286v0m-5.143 0h8.572A3.43 3.43 0 0 1 19.286 21a.857.857 0 0 1-.857.858H1.286"
    }, null, -1)
  ]))]))
}
export default { render: render }